import { call, put, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'
import { transfersFromCached } from '../../../lib/common'
import * as saleDetailConstant from './constants'
import * as saleDetailAction from './actions'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}
function nvkdRequestApi(formData) {
  const request = axiosApi().post(
    saleDetailConstant.SALE_DETAIL_REPORT_NVKD_API,
    formData
  )

  return handleRequest(request);
}
function* saleDetailReportNvkdRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(nvkdRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(saleDetailAction.saleDetailReportNvkdSuccess(results.data))

  } catch (error) {
    yield put(saleDetailAction.saleDetailReportNvkdError(error))
  }
}
function khRequestApi(formData) {
  const request = axiosApi().post(
    saleDetailConstant.SALE_DETAIL_REPORT_KH_API,
    formData
  )

  return handleRequest(request);
}
function* saleDetailReportKhRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const { data } = yield call(khRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(saleDetailAction.saleDetailReportKhSuccess(transfersFromCached(data)))

  } catch (error) {
    yield put(saleDetailAction.saleDetailReportKhError(error))
  }
}
function khoXuatRequestApi(formData) {
  const request = axiosApi().post(
    saleDetailConstant.SALE_DETAIL_REPORT_KHOXUAT_API,
    formData
  )

  return handleRequest(request);
}
function* saleDetailReportKhoXuatRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const { data } = yield call(khoXuatRequestApi, payload)
    // dispatch the action with our widgets!
    yield put(saleDetailAction.saleDetailReportKhoXuatSuccess(transfersFromCached(data)))

  } catch (error) {
    yield put(saleDetailAction.saleDetailReportKhoXuatError(error))
  }
}
function listRequestApi(formData) {
  const request = axiosApi().post(
    saleDetailConstant.SALE_DETAIL_REPORT_LIST_API,
    formData
  )

  return handleRequest(request);
}

function* saleDetailReportListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(saleDetailAction.saleDetailReportListSuccess(results.data))

  } catch (error) {
    yield put(saleDetailAction.saleDetailReportListError(error))
  }
}

function exportXlsRequestApi(formData) {
  const url = saleDetailConstant.SALE_DETAIL_REPORT_EXPORT_XLS_API + "?s=" + formData.store_id + "&st=" + formData.tu_ngay + "&ed=" + formData.den_ngay
    + "&ldh=" + formData.loaiDonHang + "&ql=" + formData.treeQL + "&kd=" + formData.listNvkd + "&dtt=" + formData.daThanhToan
    + "&nkh=" + formData.listNhomKh + "&kh=" + formData.listKH + "&kx=" + formData.listKhoXuat + "&tt=" + formData.trangThai + "&kw=" + formData.keyword;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* reportExportXlsRequestFlow(action) {
  const { formData, callback } = action
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(saleDetailAction.reportExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(saleDetailAction.reportExportXlsError(error))
  }
}
function* saleDetailReportNhomKhRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      saleDetailConstant.SALE_DETAIL_REPORT_NHOMKH_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(saleDetailAction.saleDetailReportNhomKhSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(saleDetailAction.saleDetailReportNhomKhError(error))
  }
}
function* saleDetailReportKhByNhomRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      saleDetailConstant.SALE_DETAIL_REPORT_KH_BY_NHOM_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(saleDetailAction.saleDetailReportKhByNhomSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(saleDetailAction.saleDetailReportKhByNhomError(error))
  }
}
function* saleDetailReportWatcher() {
  yield [
    takeLatest(saleDetailConstant.SALE_DETAIL_REPORT_KHOXUAT_REQUESTING, saleDetailReportKhoXuatRequestFlow),
    takeLatest(saleDetailConstant.SALE_DETAIL_REPORT_NVKD_REQUESTING, saleDetailReportNvkdRequestFlow),
    takeLatest(saleDetailConstant.SALE_DETAIL_REPORT_KH_REQUESTING, saleDetailReportKhRequestFlow),
    takeLatest(saleDetailConstant.SALE_DETAIL_REPORT_LIST_REQUESTING, saleDetailReportListRequestFlow),
    takeLatest(saleDetailConstant.SALE_DETAIL_REPORT_EXPORT_XLS_REQUESTING, reportExportXlsRequestFlow),
    takeLatest(saleDetailConstant.SALE_DETAIL_REPORT_NHOMKH_REQUESTING, saleDetailReportNhomKhRequestFlow),
    takeLatest(saleDetailConstant.SALE_DETAIL_REPORT_KH_BY_NHOM_REQUESTING, saleDetailReportKhByNhomRequestFlow),
  ]
}

export default saleDetailReportWatcher



// WEBPACK FOOTER //
// ./src/views/Reports/SaleDetailReport/sagas.js